import { useDialog } from "@common/components/alert/dialog/useDialog"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import React, {
    forwardRef,
    useCallback,
    useContext,
    useImperativeHandle,
    useRef,
} from "react"
import { Button, Dialog, IconButton, Portal, Text } from "react-native-paper"
import {
    DIALOG_CLOSE,
    trackDialogButton,
} from "../../../../ports/primary/ui/hooks/trackDialogButton"
import { ChampionImageM } from "../../../../student/champions/ChampionImageM"

let currentRef = null
export const DialogComponent = forwardRef((props, ref) => {
    const { config, ...defaultOptions } = props
    const { show, hide, isVisible, options, data } = useDialog({
        defaultOptions,
    })

    const dimensions = useContext(DimensionsContext)

    useImperativeHandle(
        ref,
        useCallback(
            () => ({
                show,
                hide,
            }),
            [hide, show]
        )
    )

    const championCenteredStyle = {
        alignItems: data?.champion ? "center" : null,
        textAlign: data?.champion ? "center" : null,
    }
    return (
        <Portal>
            <Dialog
                visible={isVisible}
                onDismiss={() => {
                    hide()
                }}
                dismissable={false}
                style={{
                    maxWidth: dimensions?.width/2,
                    alignSelf: "center",
                    backgroundColor: theme.colors.white,
                    borderRadius: 20,
                    elevation: 11,
                    zIndex: 11,
                    paddingTop: 10,
                }}
            >
                {data?.champion && (
                    <Dialog.Content style={{ alignItems: "center" }}>
                        <ChampionImageM
                            style={{ alignSelf: "center", marginBottom: -30 }}
                            name={data?.champion}
                            variant={data?.variant ?? "main"}
                            width={100}
                        />
                    </Dialog.Content>
                )}
                <Dialog.Title style={championCenteredStyle}>
                    {data.text1}
                </Dialog.Title>
                <DimensionsContext.Provider
                    value={{
                        width: dimensions?.width,
                        height: dimensions?.height,
                    }}
                >
                    <Dialog.Content style={championCenteredStyle}>
                        {data?.component ? (
                            data?.component
                        ) : (
                            <Text
                                variant="bodyMedium"
                                style={championCenteredStyle}
                            >
                                {data.text2}
                            </Text>
                        )}
                    </Dialog.Content>
                </DimensionsContext.Provider>
                <Dialog.Actions style={{ flexWrap: "wrap" }}>
                    {!data.hideButton1 && (
                        <Button
                            style={{
                                width: "100%",
                                marginBottom: 10,
                            }}
                            labelStyle={{
                                fontFamily: "Montserrat-Bold",
                                flexWrap: "wrap",
                            }}
                            mode={"contained"}
                            disabled={data?.buttonDisabled1}
                            buttonColor={
                                data?.buttonColor1 ?? theme.colors.primary
                            }
                            textColor={theme.colors.white}
                            onPress={() => {
                                trackDialogButton(
                                    data.text1,
                                    data.buttonText1 ?? "OK"
                                )
                                options.onPress()
                                hide()
                            }}
                        >
                            {data.buttonText1 ?? "OK"}
                        </Button>
                    )}
                    {data?.buttonText3 && (
                        <Button
                            style={{
                                width: "100%",
                                marginBottom: 10,
                            }}
                            labelStyle={{
                                //     color: theme.colors.white
                                fontFamily: "Montserrat-Bold",
                                flexWrap: "wrap",
                                marginBottom: 10,
                            }}
                            buttonColor={
                                data?.buttonColor3 ?? theme.colors.white
                            }
                            textColor={
                                data?.buttonColor3
                                    ? theme.colors.white
                                    : theme.colors.primary
                            }
                            mode={data?.buttonColor3 ? "contained" : "outlined"}
                            onPress={() => {
                                trackDialogButton(
                                    data.text1,
                                    data.buttonText3
                                )
                                options.onPress3()
                                hide()
                            }}
                        >
                            {data?.buttonText3}
                        </Button>
                    )}
                    {!data?.exitButton && data.buttonText2 && (
                        <Button
                            style={{
                                width: "100%",
                            }}
                            labelStyle={{
                                fontFamily: "Montserrat-Bold",
                                flexWrap: "wrap",
                            }}
                            textColor={
                                data.buttonColor2 ?? theme.colors.primary
                            }
                            mode={"text"}
                            onPress={() => {
                                trackDialogButton(
                                    data.text1,
                                    data.buttonText2
                                )
                                options.onPressBack()
                                hide()
                            }}
                        >
                            {data.buttonText2}
                        </Button>
                    )}
                </Dialog.Actions>
                {data?.exitButton && (
                    <Dialog.Content
                        style={{ position: "absolute", top: 0, right: 0 }}
                    >
                        <IconButton
                            icon="times"
                            iconColor={theme.colors.primary}
                            size={24}
                            style={{
                                position: "absolute",
                                right: 0,
                                top: 0,
                            }}
                            onPress={() => {
                                trackDialogButton(data.text1, DIALOG_CLOSE)
                                options.onPressBack()
                                hide()
                            }}
                        />
                    </Dialog.Content>
                )}
            </Dialog>
        </Portal>
    )
})

export function DialogM(props) {
    const dialogRef = useRef(null)

    const setRef = useCallback((ref) => {
        if (ref) {
            dialogRef.current = ref
            currentRef = ref
        }
    }, [])

    return <DialogComponent ref={setRef} {...props} />
}

DialogM.show = (params) => {
    currentRef?.show(params)
}

DialogM.hide = (params) => {
    currentRef?.hide(params)
}
